import type { TFunction } from 'i18next';
import type { PhysiologicalResult } from '../../model';
import type { AssessmentResultItemDataFragment, CardioRespAssessmentResultDataFragment } from '@/gql/graphql';

const parseCardioResp = (t: TFunction, items: AssessmentResultItemDataFragment[]): PhysiologicalResult | null => {
    const item = items.find(i => i.result.__typename === 'CardioRespResult');
    const mi = item?.moduleInstance;
    const r = item?.result as CardioRespAssessmentResultDataFragment;
    if (!mi?.name || !r) {
        return null;
    }

    return {
        moduleDefinitionIdentifier: mi.moduleDefinitionIdentifier ?? '',
        name: mi.name ?? '',
        description: mi.description ?? '',
        result: [
            {
                label: t('traineeReports:performance.physiologicalFitness.cardioResp.vo2Max'),
                value: r.vo2Max != null ? Number(r.vo2Max).toFixed(2) : t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.physiologicalFitness.cardioResp.restingHR'),
                value: r.restingHR != null ? r.restingHR : t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.physiologicalFitness.cardioResp.exerciseHR'),
                value: r.exerciseHR != null ? r.exerciseHR : t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.physiologicalFitness.cardioResp.hrvMs'),
                value: r.hrvMs != null ? r.hrvMs : t('traineeReports:na'),
            },
        ],
    };
};

export default parseCardioResp;
